import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PublicLayout from '../layouts/PublicLayout';
import HomePage from '../../../pages/public/HomePage';
import AuthPage from '../../../pages/public/AuthPage';

import { NavigationContext } from '../../../context/NavigationContext';

import AppRoute from './AppRoute';
import AppLayout from '../layouts/AppLayout';
import PublicRoute from './PublicRoute';
import { useAuth } from '../../../context/AuthContext';
import OldHomePage from '../../../pages/public/OldHomePage';
import TeamsPage from '../../../pages/public/TeamsPage';
import UseCasesPage from '../../../pages/public/UseCasesPage';
import PricingPage from '../../../pages/public/PricingPage';
import BlogPage from '../../../pages/public/BlogPage';
import { BlogPostPage } from '../../../pages/public/BlogPostPage';
import AboutUsPage from '../../../pages/public/AboutUsPage';
import SupportPage from '../../../pages/public/SupportPage';
import PrivacySecurityPage from '../../../pages/public/PrivacySecurityPage';
import PlatformOverviewPage from '../../../pages/public/PlatformOverviewPage';
import TermsOfService from '../../../pages/public/components/terms-of-service/TermsOfService';
import WebsiteTermsOfUse from '../../../pages/public/components/website-terms-of-use/WebsiteTermsOfUse';
import DPA from '../../../pages/public/components/dpa/DPA';
import PrivacyPolicy from '../../../pages/public/components/privacy-policy/PrivacyPolicy';
import SubscriptionPage from '../../../pages/private/account/SubscribePage';
import GetStartedPage from '../../../pages/private/home/GetStartedPage';

let redirectPath = '/';
const RouteTable = () => {
  const { isLoading, isAuthenticated } = useAuth();
  const generateRoutesFromCategories = (categories, basePath = '/') => {
    let routes = [];

    categories.forEach((category) => {
      // Compute the full path
      let fullpath = category.path ? `${basePath}/${category.path}`.replace(/\/+/g, '/') : '';

      // Prepare component props if any
      const componentProps = category.params ? { ...category.params } : {};

      // If the category has a component, create a route for it
      if (category.component) {
        const route = (
          <AppRoute
            key={fullpath} // Ensure keys are unique
            exact={!!category.exact} // Use the exact flag from the category if provided
            path={fullpath}
            layout={(props) => (
              <AppLayout {...props} />
            )}
            component={(props) => React.createElement(category.component, { ...props, ...componentProps })}
          />
        );
        routes.push(route);
      }

      // If the category has children, recursively generate routes for them
      if (category.children) {
        const childRoutes = generateRoutesFromCategories(category.children, fullpath);
        routes = routes.concat(childRoutes); // Merge child routes into the current routes array
      }
    });

    return routes;
  };


  if (isLoading) {
    return <div></div>; // Or a loading spinner component
  }
  return (
    <Switch>
      <PublicRoute
        exact
        path='/'
        layout={PublicLayout}
        component={HomePage}
        redirectPath={redirectPath}
      />

      <Route
        path={['/login', '/signup', '/reset_password', '/verify_email', '/link_validate_email', '/forgot_password']}
        exact
        component={AuthPage}
      />

      <PublicRoute
        exact
        path='/teams/*'
        layout={PublicLayout}
        component={TeamsPage}
        redirectPath={redirectPath}
      />

      <PublicRoute
        exact
        path='/use-cases/*'
        layout={PublicLayout}
        component={UseCasesPage}
        redirectPath={redirectPath}
      />
      <PublicRoute
        exact
        path='/pricing'
        layout={PublicLayout}
        component={PricingPage}
        redirectPath={redirectPath}
      />
      <PublicRoute
        exact
        path='/company/blog'
        layout={PublicLayout}
        component={BlogPage}
        redirectPath={redirectPath}
      />
      <PublicRoute
        exact
        path='/company/blog/posts/*'
        layout={PublicLayout}
        component={BlogPostPage}
        redirectPath={redirectPath}
      />
      <PublicRoute
        exact
        path='/company/about-us'
        layout={PublicLayout}
        component={AboutUsPage}
        redirectPath={redirectPath}
      />
      <PublicRoute
        exact
        path='/company/support'
        layout={PublicLayout}
        component={SupportPage}
        redirectPath={redirectPath}
      />

      <PublicRoute
        exact
        path='/platform/overview'
        layout={PublicLayout}
        component={PlatformOverviewPage}
        redirectPath={redirectPath}
      />

      <PublicRoute
        exact
        path='/company/security'
        layout={PublicLayout}
        component={PrivacySecurityPage}
        redirectPath={redirectPath}
      />
      <PublicRoute
        exact
        path='/legal/terms-of-service'
        layout={PublicLayout}
        component={TermsOfService}
        redirectPath={redirectPath}
      />
      <PublicRoute
        exact
        path='/legal/website-terms-of-use'
        layout={PublicLayout}
        component={WebsiteTermsOfUse}
        redirectPath={redirectPath}
      />

      <PublicRoute
        exact
        path='/legal/dpa'
        layout={PublicLayout}
        component={DPA}
        redirectPath={redirectPath}
      />
      <PublicRoute
        exact
        path='/legal/privacy-policy'
        layout={PublicLayout}
        component={PrivacyPolicy}
        redirectPath={redirectPath}
      />

      {/*<PublicRoute*/}
      {/*  exact*/}
      {/*  path='/oldhome/*'*/}
      {/*  layout={PublicLayout}*/}
      {/*  component={OldHomePage}*/}
      {/*  redirectPath={redirectPath}*/}
      {/*/>*/}
      <AppRoute
        key='/settings/edit-plan' // Ensure keys are unique
        exact={true} // Use the exact flag from the category if provided
        path='/settings/edit-plan'
        layout={(props) => (
          <AppLayout {...props} />
        )}
        component={(props) => <PricingPage isPublic={false} />}

      />
      <AppRoute
        key='/settings/subscribe' // Ensure keys are unique
        exact={true} // Use the exact flag from the category if provided
        path='/settings/subscribe'
        layout={(props) => (
          <AppLayout {...props} />
        )}
        component={(props) => <SubscriptionPage />}

      />

       <AppRoute
        key='/home/get-started' // Ensure keys are unique
        exact={true} // Use the exact flag from the category if provided
        path='/home/get-started'
        layout={(props) => (
          <AppLayout {...props} />
        )}
        component={(props) => <GetStartedPage />}

      />

      {isAuthenticated &&
        <NavigationContext.Consumer>
          {(categoryList) => categoryList ?
            generateRoutesFromCategories(categoryList)
            : null //or some loading spinner
          }
        </NavigationContext.Consumer>
      }


      {/*<Route*/}
      {/*  exact*/}
      {/*  path='/upload_data'*/}
      {/*  layout={MainLayout}*/}
      {/*  component={ManageDataPage}*/}
      {/*  redirectPath={redirectPath}*/}
      {/*/>*/}


      {/*<LayoutRoute*/}
      {/*  exact*/}
      {/*  path='/pricing'*/}
      {/*  layout={props => (*/}
      {/*    <MainLayout {...props} />*/}
      {/*  )}*/}

      {/*  component={props => (*/}
      {/*    <PricingPage {...props} />*/}
      {/*  )}*/}

      {/*/>*/}


      <Redirect to='/' />
    </Switch>
  );
};

export default RouteTable;